import {Alert, AlertTitle, Box, Modal} from "@mui/material";
import T from "i18n-react";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";

export const DownloadFailedModalComponent = ({isDocumentUnavailableModalOpen, setIsDocumentUnavailableModalOpen}) => {

    return <Modal open={isDocumentUnavailableModalOpen} onClose={() => setIsDocumentUnavailableModalOpen(false)}>
        <Box className="documentUnavailableModal">
            <Alert severity='info' className={'documentUnavailableAlert'}>
                <AlertTitle variant="h6" className={'documentUnavailableAlertTitle'}>
                    {T.translate('download.failed')}
                </AlertTitle>
                <CloseIcon color="action" className={'documentUnavailableCloseIcon'}
                           onClick={() => setIsDocumentUnavailableModalOpen(false)}/>
                <Button variant="contained" className={'documentUnavailableConfirmButton'}
                        onClick={() => setIsDocumentUnavailableModalOpen(false)}>OK</Button>
            </Alert>
        </Box>
    </Modal>
};